import { types as t } from 'mobx-state-tree';

export const StagingAreas = t.model('StagingAreas', {
  id: t.identifier,
  name: t.string,
});
